import pxToRem from "../utils/pxToRem"

export const fontSizes = {
  cta: pxToRem(20),
  navLinks: {
    s: pxToRem(36),
    sm: pxToRem(36),
    md: pxToRem(24),
    lg: pxToRem(30)
  },
  navSearch: {
    md: pxToRem(30)
  },
  language: {
    sm: pxToRem(30)
  },
  letterSpacing: ".01rem"
}
